export enum CloudinaryFormatType {
  image = "image",
  video = "video",
  audio = "audio",
  document = "document",
}

export const CloudinaryFormat = {
  image: [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "webp",
    "heic",
    "avif",
    "bmp",
    "svg",
    "tiff",
    "ico",
    "jxl",
  ],
  video: ["mp4", "webm", "mov", "avi", "flv", "mkv"],
  audio: ["mp3", "ogg", "wav", "aac"],
  document: ["pdf", "doc", "docx", "ppt", "pptx", "xls", "xlsx", "txt", "rtf"],
  findFormat: (format: string): CloudinaryFormatType =>
    CloudinaryFormat.image.includes(format)
      ? CloudinaryFormatType.image
      : CloudinaryFormat.video.includes(format)
        ? CloudinaryFormatType.video
        : CloudinaryFormat.audio.includes(format)
          ? CloudinaryFormatType.audio
          : CloudinaryFormatType.document,
};
